export default "__VITE_ASSET__BmSPCfRF__"